<template>
  <section class="min-h-screen flex items-stretch text-white bg-[#F7F7F7]">
    <!-- Side Menu -->
    

    <!-- Main Content -->
    <div class="flex-1 flex flex-col items-center py-6 md:px-16 px-4 z-0">
      <!-- Instructions Card -->
      <div id="instructions-card" class="bg-white text-black p-6 rounded-lg shadow-lg mb-6 w-full lg:w-3/4">
        <div class="flex items-center justify-center mb-4">
          <a href="#" class="flex items-center">
            <img src="../assets/images/logo.png" class="h-24" alt="Logo" />
          </a>
        </div>
        <h2 class="text-2xl font-bold mb-4 text-center text-[#090446]">404 Not Found</h2>
        <p class="mt-5 text-center"> The page you are looking for does not exist. Please contact with support team. Thanks </p>
        
      </div>
    </div>
  </section>
</template>


<script>
import Swal from 'sweetalert2'
import Api from '../router/api'
import AppMixin from '../mixins/AppMixin'

export default {
  name: 'NonEmployeeSurvey404',
  data() {
    return {
      url: '',
    }
  },
  mounted() {
    let urlToken = this.$route.fullPath.split('/')[2]
    this.url = urlToken
  },
  computed: {
  },
  methods: {
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/NonEmployeeSurvey404.vue